<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header" data-v-xyz22>
          <h4 class="card-title" v-if="!arquivado">Produtos</h4>
          <h4 class="card-title" v-if="arquivado">Produtos arquivados</h4>
          <router-link to="/app/products/product">
            <l-button wide type="primary" round v-if="permission('create_product')">
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>

          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
          <br>
          <el-checkbox v-model="arquivado">Produto arquivado</el-checkbox>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped example" lazy  ref="table"
            data-v-f3f3eg9
            row-key="id"
            :data="tableData().filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()) ||
            data.sku.toLowerCase().includes(search.toLowerCase())  ||
            data.price.toLowerCase().includes(search.toLowerCase()) ||
            data.category.toLowerCase().includes(search.toLowerCase()))"> 
            <el-table-column label="SKU" property="sku" width="160" sortable></el-table-column>
            <el-table-column label="Nome" property="name" min-width="200" sortable></el-table-column>
            <el-table-column label="Categoria" prop="category" min-width="180" />
            <el-table-column label="Filial" prop="company_name" min-width="180" v-if="showMatriz" />
            <!-- <el-table-column v-if="showItem" label="Empresa"
                             property="company" min-width="160" /> -->
            <!-- <el-table-column label="Preço (R$)" property="price" width="120" sortable></el-table-column> -->
            <!-- <el-table-column label="Limite de Venda" property="limit" width="160" sortable></el-table-column> -->
            <el-table-column label="Preço" width="100">
              <template slot-scope="scope">
              <el-button type="text" :loading="btnLoading" @click="toogleExpand(scope.row)">$</el-button>
              </template>
            </el-table-column>
            <el-table-column type="expand" width="0.5" class="teste">
              <template slot-scope="props">
                <div v-for="item in vmPrice[props.row.id]" :key="item.id">
                  <span> <b>Local:</b> {{item.vm_location}} &nbsp;&nbsp;</span> 
                  <span v-if="item.product_variant"> <b>Variação:</b> {{item.vm_location}} &nbsp;&nbsp;</span> 
                  <span> <b>Preço:</b>  {{item.price}}</span>
                  <br>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Ações" width="90">
              <div class="td-actions" data-v-abc55 slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                  <a
                  v-if="permission('edit_product') && !props.row.archived"
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="!props.row.archived"
                  content="Arquivar" placement="top-start">
                  <a
                    v-if="permission('delete_product')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDelete(props.$index, props.row)"
                  >
                    <i class="fa fa-folder"></i>
                    <!-- <i class="fa fa-close"></i> -->
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="props.row.archived"
                  content="Desarquivar" placement="top-start">
                  <a
                    v-if="permission('delete_product')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDeleteOff(props.$index, props.row)"
                  >
                    <i class="fa fa-folder-open"></i>
                    <!-- <i class="fa fa-close"></i> -->
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Button, Tooltip, Checkbox  } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Checkbox.name]: Checkbox,
  },
  computed: {
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach == 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    var ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      ciaID = ciaID
    } else {
      ciaID = ''
    }
    this.ciaID = ciaID
    this.init(ciaID)
    this.getListCompany()
    this.$watch('arquivado', ()=>{
      this.init(ciaID)
    })
  },
  data() {
    return {
      variants: {},
      images: [],
      btnLoading: false,
      arquivado: false,
      videos: [],
      vmPrice: [],
      ciaID: '',
      search: ''
    };
  },
  methods: {
    init (ciaID) {
      this.$store.dispatch("categories/listSort",{sort: '?company=' + ciaID}).then(() => {
        this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID + '&archived=' + this.arquivado}).then(() => {
          // this.$store.dispatch("products/variants/list").then(data => {
          //   this.variants = data;
          // }).then(() => {
            this.tableData()
          // })
        }).catch(err => console.log(err));
      })
    },
    tableData() {
      const products = this.$store.state.products.products;
      const categories = this.$store.state.categories.categories
      const populated = products.map(v => {
        let category, company, hasChildren
        if (v.category) {
          category = categories.find(e => e.id == v.category);
          category = category.name
        }

        hasChildren = true
        return { ...v, category, hasChildren };
      });
      console.log('pop', populated)
      return populated;
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/products/product/${row.id}`);
    },
    permission (permissao) {
      if (this.showItem) {
        return true
      }
      if (this.$store.state.general.permission.permissoes_do_usuario !== undefined) {
        var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
          if (el == permissao) {
            return true
          } 
        })
        if (x.length > 0) {
          return true
        }
        if (localStorage.getItem("parent_company")) {
          return true
        } 
      }
    },toogleExpand(row) {
      this.btnLoading = true
      this.$store.dispatch('vmPrice/listSort', {sort: '?product=' + row.id + '&page_size=50' }).then(resp => {
        this.vmPrice[row.id] = resp
        let $table = this.$refs.table;
          $table.toggleRowExpansion(row)
          this.btnLoading = false
      })
     },
    load(tree, treeNode, resolve) {
      // console.log('load tree', tree)
      // console.log('load node', treeNode)
      // console.log('load resolve', resolve)

      this.$store.dispatch('vmPrice/listSort', {sort: '?product=' + tree.id + '&page_size=50' }).then(resp => {
        resolve(resp)
      })
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = row.name;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a arquivar o produto ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, arquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("products/updatePatch", { item : {
                                                                  id: row.id,
                                                                  archived: true
                                                                  } }).then(res => {
            if (res.status !== 500) {
              swal.fire({
                title: "Pronto!",
                text: `${itemName} arquivada.`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              this.init(this.ciaID)
            } else {
              swal.fire({
                title: "Ops!",
                text: `${itemName} não arquivada.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não arquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    handleDeleteOff(i, row) {
      console.log(row);
      const itemName = row.name;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a desarquivar o produto ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, desarquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("products/updatePatch", { item : {
                                                                  id: row.id,
                                                                  archived: false
                                                                  } }).then(res => {
            if (res.status !== 500) {
              swal.fire({
                title: "Pronto!",
                text: `${itemName} desarquivada.`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              this.init(this.ciaID)
            } else {
              swal.fire({
                title: "Ops!",
                text: `${itemName} não desarquivada.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não desarquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style >
.td-actions[data-v-abc55] > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header[data-v-xyz22] {
  display: flex;
}
.card-header[data-v-xyz22] a {
  margin-left: auto;
}

.example[data-v-f3f3eg9] .el-table__expand-icon {
  display: none; 
  /* ESSE AQUI!! */
}

</style>

